module.exports = __webpack_public_path__ + "static/media/S (42).c93d400b.jpg";